<template>
	<div id="family-page">
		<content-view :color="color">
			<template slot="intro">
				<div class="center">
					<div class="text">
						<h1 v-collide="'fadeInLeft'">На пике формы</h1>
						<p v-collide="'fadeInUp'">
							Хочешь укрепить отношения в семье? Превратить дом в настоящую крепость и всегда
							оставаться для родных гарантом безопасности и комфорта так же, как и новый KIA Sportage,
							который при помощи самых современных технологий заботится о безопасности водителя
							и пассажиров? В этом тебе поможет Лариса Суркова – автор 18 книг, профессиональный
							психолог и консультант в области семейных отношений, которая знает, как важен комфорт
							в семье и почему не стоит им пренебрегать.
						</p>

						<div class="wrap">
							<img :src="getImg('intro-text-image.png')" v-collide="'fadeInUp'">
							<p v-collide="'fadeInRight'">
								Лариса подготовила для тебя персональные программы по развитию
								и улучшению семейных отношений, рассчитанные на 4 месяца.
								Чтобы получить их — нужно просто оставить свой мейл.
							</p>
						</div>
					</div>
				</div>
			</template>
			<template slot="programs">
				<div id="program-1" :class="{'visible': visible.first}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 1</h2>
									<a v-if="!visible.first" class="button button-show" @click="visible.first = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<p v-if="visible.first" v-collide="'fadeInLeft'">В любой семье можно столкнуться с целым рядом сложностей, которые, к сожалению, для мног
									их пар становятся неразрешимыми. Но почему в самом начале отношений все так прекрасно, а потом
									начинаются сложности? </p>
								<h3 v-if="visible.first" v-collide="'fadeInUp'">Твоя Семья</h3>
							</div>
							<img v-if="visible.first" :src="getImg('program-1-1.png')" v-collide="'fadeInRight'">
						</div>
						<div v-if="visible.first" class="program-blocks">
							<div class="program-block program-block-1" >
								<div class="row-with-picture">
									<div class="text" v-collide="'fadeInLeft'">
										<p>
											Давайте разбираться и искать пути решения. И первый урок – научиться разговаривать друг с другом,
											строить диалог, не переходя сразу в привычное нападение с обвинениями и оскорблениями. Когда жена
											говорит: «Я целый день одна и уже устала сидеть дома», то это не значит, что она хочет в чем обвинить
											мужа. Это значит, что она хочет, чтобы ее обняли и сказали, как любят и ценят.
										</p>
									</div>
								</div>
							</div>

							<div class="program-block program-block-2">
								<div class="row-with-picture">
									<img :src="getImg('program-1-2.png')" v-collide="'fadeInLeft'">
									<div class="text" v-collide="'fadeInRight'">
										<p>
											Если муж говорит: «Я хочу пять минут тишины», то это
											не значит, что он не любит жену. Ему просто нужно дать
											эти пять минут.Но получается, что в семье мы часто
											говорим словно на разных языках. Так что же делать,
											чтобы лучше понимать друг друга?
										</p>
									</div>
								</div>
							</div>

							<div class="program-block program-block-3">
								<div class="row-with-picture">

									<div class="text rules rules-1" v-collide="'fadeInLeft'">
										<h5>3 правила</h5>
										<p>
											Всегда выслушивать до конца. Часто перебиваете
											партнера? Тогда начните медленно считать про себя«один, два три». Так с большой доли вероятности
											он или она сможет донести свою мысль до конца
											и привычный конфликт отступит.
										</p>
									</div>
									<img :src="getImg('program-1-3.png')" v-collide="'fadeInRight'">
								</div>
								<div class="text rules rules-2" v-collide="'fadeInLeft'">
									<p>
									Использовать метод «Я - сообщений». Формулируя претензии, говорите о своих чувствах, а не обвиняйте.
									Например, вместо фразы «Чего ты снова мою машину взяла?! Она мне нужна сегодня!», скажите «Я очень
									расстроился, что ты уехала на моей машине без предупреждения». Так вторая половина сама захочет
									извиниться и задобрить вас.
									</p>
								</div>
								<div class="text rules rules-3" v-collide="'fadeInRight'">
									<p>
										Практиковать диалоги. Устройте ужин и просто поговорите
										обо всем на свете, без надоедливых смартфонов. И поступайте
										так регулярно – хотя бы два раза в неделю.
									</p>
								</div>
							</div>
						</div>
						<div v-if="visible.first" class="results" v-collide="'fadeInLeft'">
							<p>
								Итоги нашего первого занятия - говорите, слушайте и отвечайте, и будет вам счастье! Следующий урок будет посложнее.
							</p>
							<a @click="visible.first = false" v-if="visible.first" class="button button-hide">
								<span>Скрыть</span>
							</a>
						</div>
					</div>
					<Sides/>
				</div>

				<div id="program-2" :class="{'visible': visible.second}">
					<div class="center">
						<div class="program-header">
							<div class="text">
								<div class="header">
									<h2 v-collide="'fadeInUp'">Программа 2</h2>
									<a v-collide="'fadeInUp'" v-if="!visible.second" class="button button-show" @click="visible.second = true">
										<span>Узнать подробнее</span>
									</a>
								</div>
								<h3 v-if="visible.second" v-collide="'fadeInUp'">Твоя семья</h3>
								<div v-if="visible.second" v-collide="'fadeInUp'">
									<p>Первый год после рождения ребенка — серьезное испытание для пары: бурлящие гормоны
										мамы, уставший папа, отсутствие нормального общения. Словом, богатый коктейль из неврозов.
									</p>
								</div>
							</div>
						</div>
						<div v-if="visible.second" class="program-blocks">
							<div  class="program-block program-block-1">
								<div class="row-with-picture" >
									<div v-collide="'fadeInLeft'" class="text">
										<p>
											Сегодня мы узнаем, как сохранить гармоничные отношения в семье после рождения ребенка.
										</p>
									</div>
									<img v-collide="'fadeInRight'" :src="getImg('program-2-1.png')" >
								</div>
							</div>
							<div class="program-block program-block-2">
								<div class="row-with-picture">
									<img v-collide="'fadeInLeft'" :src="getImg('program-2-2.png')">
									<div v-collide="'fadeInRight'"  class="text">
										<ul>
											<li>Установите за правило не кричать друг на друга при ребенке. Обязательно придумайте
											кодовое слово (например «лимон»), чтобы остановить нарушителя и прекратить
												словесную перепалку.</li>

											<li>У вас должно быть время на разговор. Конечно, ребенок сейчас — это самое важное,
												но еще есть работа, политика и погода.</li>
										</ul>
									</div>
								</div>
							</div>
							<div class="program-block program-block-3">
								<div class="row-with-picture">
									<div v-collide="'fadeInLeft'" class="text">
										<ul>
											<li>Взрослое время. Установите время, после которого вы — муж и жена. Малыш уснул? Отодвиньте уборку/готовку и просто полежите рядом с любимым.</li>
											<li>Касайтесь друг друга. Объятия нужны не только детям!</li>
										</ul>
									</div>
									<img v-collide="'fadeInRight'"  :src="getImg('program-2-3.png')">
								</div>
							</div>
							<div  class="program-block program-block-4">
								<div class="row-with-picture">
									<img v-collide="'fadeInLeft'" :src="getImg('program-2-4.png')">
									<div v-collide="'fadeInRight'" class="text">
										<ul>
											<li>Не нужно делать сто дел одновременно — вы не супермен, и это нормально..</li>

											<li>Папы, поддержите жену! Сестра прислала шутку: «Только рожая, женщина
											может понять муки, которые испытывает мужчина с температурой 37,2».
											Так вот, папы, представьте, что у вашей жены несколько месяцев 37,2: она
											правда устает, а не просто «сидит дома». Да, после рождения ребенка у вас многое изменилось, но у нее изменений больше: в ее голове
											клубок из переживаний, страхов, недосыпа и голодовки. Ей очень нужна
											ваша поддержка! Семья — это всегда история на двоих. Жить вместе —
											это искусство.</li>
										</ul>
									</div>

								</div>
							</div>
						</div>
						<a v-collide="'fadeInRight'" @click="visible.second = false" v-if="visible.second" class="button button-hide"><span>Скрыть</span></a>
					</div>


					<Sides/>
				</div>
			</template>


			<template slot="programs_bottom">
				<div id="program-3" :class="{'visible': visible.third}">
					<div class="center">
						<div class="program-header">
							<div   class="header">
								<h2 v-collide="'fadeInLeft'">Программа 3</h2>
								<a v-collide="'fadeInLeft'"  v-if="!visible.third" class="button button-show" @click="visible.third = true">
									<span>Узнать подробнее</span>
								</a>
							</div>
							<div v-if="visible.third" class="text"  v-collide="'fadeInLeft'" >

								<h3 >Семья</h3 >
								<p>
									На крепкие мужские плечи возложены самые важные функции в семье.
								</p>
								<p>
									Поэтому, дорогие папы! Помимо того, что вы символизируете опору и безопасность, вы даете ребенку уверенность в себе и ответственны за то, каким будет его мир и он сам.
								</p>
								<p >
									Поймите, запомните: вы очень нужны. И не только тогда, когда ваши дети уже самостоятельно ходят в школу и способны поддержать интересную вам беседу. "Когда он подрастет, будем играть в футбол,
									а пока - как с ним общаться?’’ – не совсем верная стратегия. Вы нужны всегда, с самого начала –
									и пока ребенок маленький, беззащитен и нуждается в опеке, и когда он подрастет и начнет познавать мир самостоятельно.

								</p>
							</div>
							<img v-if="visible.third" :src="getImg('program-3-1.png')" v-collide="'fadeIn'">
						</div>
						<div v-if="visible.third" class="program-blocks">
							<div  class="program-block program-block-1">
								<div class="text">
									<p v-collide="'fadeInLeft'">
										Понимаю, что многие из вас очень заняты, но не упустите самое важное. Скорее всего, спустя годы вы будете жалеть о том, что не уделили в свое
										время должного внимания, не выкроили время для того, чтобы ваша
										связь с сыном или дочерью была крепкой, основывалась на любви,
										искренности и доверии. Ведь его мир начинается с вас.
									</p>
									<p v-collide="'fadeInRight'" class="bigger">
										Найдите хотя бы полчаса в день в будни
										и постарайтесь проводить вместе выходные,
										хотя бы один день из двух.
									</p>
									<p v-collide="'fadeInLeft'">
										Поверьте, пройдут годы, и вы будете с улыбкой и теплотой вспоминать именно эти мгновения.
									</p>
								</div>
							</div>
							<div class="program-block program-block-2" >
								<div class="row-with-picture">
									<img v-if="visible.third" :src="getImg('program-3-2.png')" v-collide="'fadeIn'">
									<div class="text"  v-collide="'fadeInRight'">
										<p class="bigger">
											Например, выберитесь на прогулку
											в вечернем парке -
										</p>
										<p>
											даже короткие прогулки на свежем воздухе всегда
											заряжают силами.
										</p>
										<p>
											Главное – помните, то время и внимание, которое вы уделяете самым близким людям, не только сближает вас, но и заряжает положительными эмоциями, которые так важно разделять друг с другом.

										</p>
									</div>

								</div>
							</div>
						</div>
					</div>
					<a @click="visible.third = false" v-if="visible.third" class="button button-hide">
						<span>Скрыть</span>
					</a>
				</div>
				<Sides/>
				<Subscribe />
			</template>
			<template slot="product">
				Новый KIA Sportage станет твоим проводником в мир, полный открытий
				и приключений, ведь это автомобиль - на пике формы! И в нем воплотились
				самые передовые инновации и продвинутые технологии, которые гарантируют
				максимальное удобство вождения и безопасность. Например, интеллектуальный
				круиз-контроль, который в пробках определяет скорость и расстояние до
				едущего впереди автомобиля, поддерживая безопасную дистанцию. Еще
				большего комфорта в дороге добавит система мониторинга слепых зон,
				предупреждающая водителя во время перестроения. И, наконец, удобная
				система помощи при выезде с парковки задним ходом, которая всегда
				предупредит о приближающихся автомобилях.
			</template>
		</content-view>
	</div>
</template>


<script>
    import ContentView from '@/components/ContentV2'
    import Sides from '@/components/Sides'
    import Subscribe from '@/components/Subscribe'
    import { colors } from '@/data/pages'
    import LINKS from '@/data/links';

    export default {
        name: 'Family',
        components: {
            ContentView,
            Sides,
            Subscribe
        },
        data() {
            return {
                visible: {
                    first: false,
                    second: false,
                    third: false
                },
                color: colors[this.$route.name],
            }
        },
        computed: {
            learnmoreLink() {
                return LINKS[this.route]
            },
        },
        methods: {

            getImg(name) {
                return require(`@/assets/images/${this.$route.name}/${name}`)
            },
        }
    }
</script>

<style lang="less">
	@import '../styles/variables';

	#family-page {
		#program-1 {
			position: relative;
			z-index: 11;
			.program-header {
				h2 {
					display: block;
					margin-bottom: 0;
				}
				h3 {
					margin-top: 10px;
				}
				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
					}

					@media (min-width: 960px) {
						right: 0;
						width: 100%;
						max-width: 70%;
						margin-left: auto;
						left: 20%;
					}
				}

				.text {
					margin-top: 70px;
					margin-bottom: 30px;
					z-index: 3;
					position: relative;
					@media (min-width: 960px) {
						left: 10%;
						max-width: 70%;
						margin-bottom: 0;
					}
					&:before {
						content: "";
						display: block;
						position: absolute;
						right: -120px;
						top: -10px;
						width: 70px;
						height: 110px;
						background: url('../assets/images/family/heart.png') no-repeat center center;
						background-size: contain;
					}
					&:after {
						content: "";
						display: block;
						position: absolute;
						left: 25%;
						top: -35%;
						width: 50%;
						height: 800px;
						background: url('../assets/images/family/dots-1.png') no-repeat center center;
						background-size: contain;
					}
				}

			}

			.sides {
				bottom: 0;
			}
			h5 {
				font-size: 24px;
				text-transform: uppercase;
				font-family: @font-bold;
				position: relative;
				z-index: 1;
			}

			@media (min-width: 960px) {
				.program-block-1 {
					margin-top: 60px;
					margin-left: 10%;
					.text {
						padding-right: 40px;
						max-width: 75%;
					}
					img {
						max-width: 50%;
					}
				}

				.program-block-2 {
					.row-with-picture {
						align-items: flex-end;
					}
					img {
						max-width: 60%;
						margin-left: -20%;
					}
					.text {
						position: relative;
						top: -30px;
						margin-left: 10%;
						max-width: 40%;
					}
				}
				.program-block-3 {
					margin-left: 10%;
					max-width: 90%;

					img {
						max-width: 60%;
					}
					.rules {
						position: relative;
						&:after {
							content: "";
							font-family: @font-bold;
							display: block;
							font-size: 100px;
							color: #000;
							position: absolute;
							z-index: 0;
							top: -50px;
							left: 48px;
						}
						&-1:after {
							content: "1";
						}
						&-2:after {
							content: "2";
						}
						&-3:after {
							content: "3";
						}
						p {
							position: relative;
							z-index: 1;
						}
						&-3 {
							margin-top: 60px;
							margin-left: 50%;
						}
					}
				}
				.results {
					margin-left: 10%;
					max-width: 50%;
					font-size: 15px;
					p {
						margin-bottom: 20px;
					}
				}


			}
			.program-block-2 {

			}
			.program-block-3 {
				margin-top: 90px;
				margin-bottom: 90px;
			}
			.button {
				margin-bottom: 60px;
				&:after {
					display: none;
				}
			}
			.header {
				width: auto;
				display: inline-block;
				text-align: center;
				position: relative;
				&:before {
					content: "";
					display: block;
					position: absolute;
					left: -70px;
					top: -10px;
					width: 50px;
					height: 50px;
					background: url('../assets/images/family/duck.png') no-repeat center center;
					background-size: contain;
				}
				&:after {
					content: "";
					display: block;
					width: 230px;
					height: 65px;
					background: #325eba;
					position: absolute;
					bottom: -30px;
					left: -20px;
				}
			}
			.button-show {
				left: 0;
				margin: 0 auto;
				display: inline-block;
			}
		}
		#program-2 {
			position: relative;
			z-index: 1;
			margin-bottom: 60px;
			@media (min-width: 960px) {
				margin-bottom: 0;
			}
			&:before {
				content: "";
				display: block;
				position: absolute;
				left: 20%;
				top: -320px;
				width: 60%;
				height: 920px;
				background: url('../assets/images/dots-1.png') no-repeat center center;
				background-size: contain;
			}
			&.visible:before {
				display: none;
			}

			@media (min-width: 960px) {
				margin-top: -75px;
			}
			&.visible {
				margin: 0;
			}
			.program-header {

				.text {
					margin-bottom: 30px;
					z-index: 3;
					@media (min-width: 960px) {
						margin-left: 5%;
					}
					p {
						@media (min-width: 960px) {
							max-width: 70%;
							margin-bottom: 16px;
						}
					}
				}

				h2 {
					display: block;
				}

				p {
					position: relative;
					font-family: @font-light;
					font-size: 16px;
					z-index: 1;
				}
			}
			img {
				display: block;
				margin-top: 60px;
				width: 100%;
			}
			.header {
				width: auto;
				display: inline-block;
				text-align: center;
				white-space: nowrap;
				@media (min-width: 960px) {
					margin-left: 40%;
				}
			}
			.button {
				margin-top: 30px;
				margin-bottom: 30px;
				&:after {
					background: #325eba;
					left: auto;
					right: -60px;
					transform: skew(-45deg);
				}
				@media (min-width: 960px) {
					margin-top: 60px;
					margin-bottom: 120px;
				}
			}

			.program-block-1 {
				li {
					margin-bottom: 20px;
				}
			}

			@media (min-width: 960px) {

				.program-block-1 {
					margin-left: 5%;
					max-width: 95%;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						position: relative;
						top: -120px;
						max-width: 40%;
						margin-right: 10%;
					}
					img {
						max-width: 50%;
					}
				}
				.program-block-2 {
					img {
						width: 70%;
						position: relative;
						margin-left: -20%;
						top: -72px;
					}
					.text {
						margin-left: 10%;
					}
				}
				.program-block-3 {
					.row-with-picture {
						align-items: flex-start;
					}
					img {
						margin: 0;
						width: 50%;
						position: relative;
					}
					.text {
						margin-left: 5%;
						margin-right: 5%;
						margin-top: 80px;
					}
				}
				.program-block-4 {
					margin-bottom: 320px;
					.row-with-picture {
						align-items: flex-end;
					}
					img {
						margin: 0;
						margin-right: 10%;
						width: 40%;
						position: relative;
					}
					.text {
						position: relative;
						top: -30px;
					}
				}
				.button {
					position: absolute;
					right: 12.5%;
					bottom: 180px;
					margin-top: 0;
					margin-bottom: 0;
				}
				.button-show {
					position: relative;
					display: inline-block;
					bottom: 0;
					right: auto;
					margin: 0 auto;
					margin-bottom: 120px;
				}
			}
		}

		#banner {
			&:before {
				background: url('../assets/images/family/plus.png') no-repeat center center;
				width: 10%;
				background-size: contain;
			}
			&:after {
				display: none;
			}
		}

		#program-3 {
			.program-header {
				position: relative;
				&:before {
					content: "";
					display: block;
					position: absolute;
					left: 50%;
					top: 40px;
					width: 50px;
					height: 50px;
					background: url('../assets/images/family/duck.png') no-repeat center center;
					background-size: contain;
				}
				&:after {
					content: "";
					display: block;
					position: absolute;
					left: -40px;
					top: -10px;
					width: 120px;
					height: 120px;
					background: url('../assets/images/family/plus.png') no-repeat center center;
					background-size: contain;
				}
				img {
					position: relative;
					width: calc(~'100% + 40px');
					z-index: 2;
					display: block;
					margin-top: 30px;
					@media (max-width: 959px) {
						left: -20px;
						width: 100%;
					}

					@media (min-width: 960px) {
						margin-left: auto;
						width: 100%;
						max-width: 60%;
						left: 20%;
					}
				}

				.text {
					margin-top: 65px;
					p {
						margin-bottom: 16px;
					}
					@media (min-width: 960px) {
						left: 5%;
						max-width: 60%;
					}
				}

				.header {
					margin-top: 30px;
					font-size: 16px;
					position: relative;
					font-family: @font-light;

					@media (min-width: 960px) {
						text-align: center;
						left: 5%;
						width: 95%;
						max-width: 45%;
					}
				}
			}

			.button-show {
				display: inline-block;
				&:after {
					background: #325eba;
				}
			}
			.button-hide {
				position: relative;
				@media (min-width: 960px) {
					margin-top: 160px;
					left: 17.5%;
				}
				&:after {
					background: #325eba;
					bottom: auto;
					top: -30px;
					transform: skew(-45deg);
				}
			}
			@media (min-width: 960px) {
				.program-block-1 {
					margin-left: 5%;
					max-width: 95%;
					margin-bottom: 0;
					p:nth-child(1) {
						max-width: 50%;
					}
					p:nth-child(2) {
						margin-left: 40%;
						max-width: 40%;
					}

				}

				.program-picture-1 {
					margin-top: 35px;
					margin-bottom: 35px;
					max-width: 70%;
				}

				.program-block-2 {
					margin-top: 60px;
					.row-with-picture {
						align-items: flex-end;
					}
					.text {
						margin-left: 10%;
						position: relative;
						top: -25px;
					}
					img {
						width: 60%;
						margin-left: -20%;
					}
				}

			}
		}
		.programs-bottom-forms {
			@media (min-width: 960px) {
				margin-top: 260px;
			}
			&:before {
				display: none;
			}
			.button {
				&:after {
					background: #325eba;
					width: 220px;
					bottom: auto;
					top: -20px;
					right: -65px;
				}
			}
			@media (min-width: 960px) {
				.inner {
					right: 10%;
				}
			}
			.inner {

				h2 {
					position: relative;
				}
			}
		}
	}
</style>
